<style lang="scss" scoped>
.deviceItemStyle{
    padding:1px 5px;
    background-color: #ebf5ff;
	border-radius: 4px;
	border: solid 1px rgba(64, 158, 255, 0.5);
}
.notRelease{
    color:#ff0000;
}
.feedbackModify{
    color:#fdc989;
}
.feedbackPass{
    color:#99e6c8;
}
.el-range-editor.el-input__inner{
    width: 100%;
    border: 0px solid #dcdfe6;
}
.timeIsEdit{
    color:#507dac;
}
.noTimeIsEdit{
    color:#323232
}
.but-fill-time{
    position: absolute;
    top: 18px;
    right: 0px;
}
.but-fill-time img{
    width: 20px;
    height: 20px;
}
</style>

<template>
   <!--  -->
    <el-table-column
        :prop="col.prop"
        :label="col.label"
        align="center"
        v-if="!col.show"
        :fixed="col.fixed"
        :min-width="width"
        :sortable="col.sortable"
		:render-header="col.renderHeader"
		:sort-method="col.sortMethod"
        :show-overflow-tooltip="editField.indexOf(col.prop) == -1"
        :formatter="formatter"
        >
        <template slot="header" slot-scope="slot" >
            <span :data-id="slot.$index" v-if="editField.indexOf(col.prop) != -1 && !col.isbitian">
                <span style="color:#ff0101">*</span>
                {{col.label}}
            </span>
            <span v-else>{{col.label}}</span>
        </template>
        <!-- :render-header="renderHeader" -->
        <template slot-scope="scope" >
            <!-- !isAdmin非管理员界面 -->
            <!-- {{console.log(scope)}} -->
            <el-input @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && !col.noNeedControl && !col.isData" type="number"  @keydown.native="channelInputLimit($event,scope.row,col.prop,col)"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
            <!-- 填写中文 -->
            <el-input  v-if="editField.indexOf(col.prop) != -1 && !isAdmin && !isNoEditRow && col.noNeedControl && !col.isData" @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small" />
            <!-- 选择日期 -->
            <el-date-picker @paste.native="onPaste(scope.$index,col.prop)" v-if="editField.indexOf(col.prop) != -1 && col.isData"
            @focus='getfocus($event,col,scope.$index,true)' @blur="dblur($event,true)"
                v-model="scope.row[col.prop]"
                style="width: 100%"
                type="date"
                value-format="timestamp"
                :picker-options="scope.row.pickerOptions"
                placeholder="请选择"
                
                prefix-icon="return fasle">
                <!-- :editable="false" -->
            </el-date-picker>
            
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow && scope.row.chargeType!='0001'"> {{strGetVal(col.prop,scope)}}</span>
            <!--项目 填报详情 查看-->
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow && scope.row.chargeType=='0001' &&col.prop== 'chargeItemDesc'" class="deviceItemStyle"> {{strGetVal(col.prop,scope)}}</span>
            <span v-if="editField.indexOf(col.prop) == -1  && !isAdmin && !isNoEditRow && scope.row.chargeType=='0001' &&col.prop!= 'chargeItemDesc'"> {{strGetVal(col.prop,scope)}}</span>

            <!--  非管理员界面 且 具有行属性-->
            <el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1 && !scope.row.isFuShu && !col.noNeedControl"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
            <!-- 填写中文 -->
            <el-input  v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1 && !scope.row.isFuShu && col.noNeedControl" @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)"  v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)"   placeholder="请输入" size="small" />
            <!--  非管理员界面 且 具有行属性--负数-->
            <el-input type="text"  v-if="editField.indexOf(col.prop) != -1 && !isAdmin && isNoEditRow &&unEditRow.indexOf(scope.$index)== -1 && scope.row.isFuShu"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" size="small" oninput="value=value.replace(/[^\d\.-]/, '').replace(/^0(?=[0-9])/, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/\.{2,}/g, '.').replace(/[^-\d.]/g, '') "/>

            <span v-if="editField.indexOf(col.prop) == -1 && !isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)== -1&& scope.row.chargeType!='0001'"> {{strGetVal(col.prop,scope)}}</span>
            <!--项目 填报详情 填报-->
            <span v-if="editField.indexOf(col.prop) == -1 && !isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)== -1 && scope.row.chargeType=='0001'" class="deviceItemStyle"> {{strGetVal(col.prop,scope)}}</span>
            

            <!-- 第一行，最后一行不可编辑 -->
            <span v-if="!isAdmin && isNoEditRow && unEditRow.indexOf(scope.$index)!= -1" style="height:100%">
                <el-input type="number" @keydown.native="channelInputLimit($event,scope.row,col.prop,col)" v-if="col.prop== 'availableMoney' || col.prop== 'investmentTotal'"  @focus='getfocus($event,col,scope.$index)' @blur="dblur($event)" v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)" :value="strGetVal(col.prop,scope)" placeholder="请输入" size="small" oninput="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'');value=value>=1?value.replace(/^[0]+/,''):value;"/>
                <el-tooltip v-else-if="scope.row.chargeType=='0000' && strGetVal(col.prop,scope)=='采购需求'" class="item" effect="dark" content="填报该项目可采购的需求类型和预计金额" placement="top-start">
                    <span>
                        <span>{{strGetVal(col.prop,scope)}}</span><i class="iconfont iconwenhao" style="float:right;margin-right:15px;"></i>
                    </span>
                </el-tooltip>
                <span v-else class="bm bm-ac bm-pc" style="height:100%;background:#f0f0f0;">{{strGetVal(col.prop,scope)}}</span>

            </span>

            <span v-else-if="col.prop== 'chargeItemDesc'&&scope.row.chargeType!='0001'&&scope.row.chargeType!='xxxx'">
                 <!-- //费用类型：”0001”：采购需求 ;”0002”:差旅费; “0003”：餐饮; “0004”：项目费 -->
                <el-tooltip class="item" effect="dark" :content="scope.row.chargeType=='采购需求'?'填报该项目可采购的需求类型和预计金额':scope.row.chargeType=='0002'?'为该项目发生的预计员工差旅':scope.row.chargeType=='0003'?'为该项目发生的预计员工餐饮':scope.row.chargeType=='0004'?'除以上三类以外的项目费用':scope.row.chargeItemDesc" placement="top-start">
                    <span >
                        <i class="iconfont iconwenhao" style="float:right;margin-right:15px;"></i>
                    </span>
                </el-tooltip>               
            </span>
            <span v-else-if="col.prop== 'chargeItemDesc'&&scope.row.chargeType=='0001'" @click.stop="questMove(strGetVal(col.prop,scope))" style="cursor:pointer;height:100%">
                <span v-if="!isCheck">
                    <i class="iconfont iconquchu" style="float:right;margin-right:15px;color:red"></i>
                </span>
            </span>
            

            <!-- 管理员界面 -->
           <div class="timeIsEdit" v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag !=2" @click="chooseTime(scope.$index, scope.row,col.prop)" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} 
                <div class="but-fill-time"><img class="bm bm-img" src="@/asserts/img/btn_Fill.png"/></div>
            </div>
            <div class="noTimeIsEdit"  v-if="editField.indexOf(col.prop) != -1 && isAdmin && scope.row.completeFlag ==2" > 
                {{parseInt(scope.row.beginFillDate) | dateformat('YYYY.MM.DD')}}
                -{{parseInt(scope.row.endFillDate) | dateformat('YYYY.MM.DD')}} </div>

            <!-- 管理员界面 发布未发布 -->
            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) != -1  && isAdmin"> 
                <!-- <div :class="strGetVal(col.prop,scope)==2?'':'notRelease'">{{strGetVal(col.prop,scope)==0?'未填报':strGetVal(col.prop,scope)==1?'未发布':'已发布'}}</div> -->

				<!-- v2.0   未发布，已发布，已反馈通过，已反馈修改 -->
                <div :class="scope.row.dataStatus == '未发布' ? 'notRelease': scope.row.dataStatus == '已反馈通过' ? 'feedbackPass': scope.row.dataStatus == '已反馈修改' ? 'feedbackModify': ''">{{scope.row.dataStatus}}</div>
            </span>

            <span v-if="completeFlagObj && completeFlagObj.name.indexOf(scope.column.property) == -1 && editField.indexOf(col.prop) == -1  && isAdmin"> {{strGetVal(col.prop,scope)}}</span>

        </template>
        <template v-if="col.children && !col.show">
            <digital-column
                v-for="(item, index) in col.children"
                :key="index"
                :col="item"
                :unEditRow="unEditRow"
                :editField="editField"
                :pasteField="pasteField"
                :height="height" 
                :formatterList="formatterList"
                :tableData="tableData"
                @modification="modificationa"
				@loseFocus="loseFocus"
                @pasteData="pasteData"
                :width="item.width">
            </digital-column>
        </template>
    </el-table-column>
    
</template>

<script>
// import moment from 'moment'
// const R = require('ramda')
export default {
    name: "digital-column-project",
    data() {
        return {
            createTime:"",
            sth:"",
            field:[],
            tempkey:"",
            fuShu: false,
            fushuNumber: "",
            currentCol:"",
            currentIndex:"",
            tLength:""//tableData行数
        };
    },
    watch:{
        col:{
            immediate:true,
            handler(val){
                // console.log(val.children)
            }
        }
    },
    props: {
        isNoEditRow:{
            type:Boolean
        },
        isAdmin:{
            type:Boolean
        },
        tableData:{
            type: Array
		},
        col: {
            type: Object
        },
        completeFlagObj:{
            type: Object
        },
        editField:{
            type: Array
        },
        pasteField:{
            type: Array,
            default: () => {
                return []
            }
        },
        isCheck:{
            type:Boolean,
            require:false,
            default:false
        },
        unEditRow:{
            type: Array
        },
        formatterList:{
            type: Array
		},
		height:{
			type: String
		},
		formatteColumn:{
			type: Object
        },
        width:{
			type: String
		}
    },
    created(){
        //console.log(this.tableData);
        // var ctrlDown = false,
        // ctrlKey = 17,
        // cmdKey = 91,
        // vKey = 86,
        // cKey = 67;
        
    },
    methods: {
          substrClipTest(clipText,data){
            let index = clipText.indexOf("\r\n");
            if(index > -1){
                let rowResult = clipText.slice(0,index).split("\t");
                data.push(rowResult);
                let text = clipText.slice(index+2);
                if(text.indexOf("\r\n") > -1){
                     this.substrClipTest(text,data);
                }
                return data;
            }
        },
         onPaste(index,prop){
            //如果不满足 黏贴列表传空pasteField=[]
            if(this.pasteField&&this.pasteField.length>0){
                navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText,'结果')
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        let editData = []; 
                        //2.结果集处理成对象 类型，字段名，内容
                        result.forEach((value,key)=>{
                            let data = [];
                            let startVal =false,i=0;
                            this.pasteField.forEach((editValue,editKey)=>{
                                if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                    startVal =true;
                                    let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                    data.push(obj);
                                    i++;
                                }
                            });
                            editData.push(data);
                        });
                        console.log("结果集",editData)
                     
                        this.tLength=this.tableData.length
                        //3.结果集 写入到表里面
                        editData.forEach((value,key)=>{
                            value.forEach((innerValue,innerKey)=>{
                                if(index+key<this.tLength-1){  //超过table行数不付值
                                    //每种类型的处理
                                    if(innerValue.isCover){
                                        if(innerValue.type == "number"){
                                            this.tableData[index+key][innerValue.key] = parseFloat(innerValue.value);
                                        }else if(innerValue.type == "date"){
                                            this.tableData[index+key][innerValue.key] = moment(innerValue.value).valueOf();
                                        }else{
                                            this.tableData[index+key][innerValue.key] = innerValue.value;
                                        }
                                    }
                                }
                                    
                            });
                        });
                        //公共处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }else{
                 navigator.clipboard.readText().then((clipText)=>{//
                    //  console.log(clipText)
                    if(clipText.indexOf("\r\n") > 0){
                        //1.剪贴版结果集
                        let result = this.substrClipTest(clipText,[]); 
                        //自己处理
                        this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                    }
                });
            }
            
        },
        pasteData(e){
            this.$emit("pasteData",e);
        },
        chooseTime(index,row,prop){
            this.$emit("openDialog",{index:index,row:row,prop:prop});
        },
        //失去焦点
		loseFocus(e){
			this.$emit("loseFocus", this.tableData);
		},
		//input 监听
		modificationa(e){
			this.$emit("modification",e);
        },
        //去除采购需求
        questMove(e){
			this.$emit("questMove",e);

        },
        //键盘监控
        getFocusKeydown(e){
            let that = this;
            $(e.target).keydown(function(e) {
                if (e.ctrlKey && (e.keyCode == 86)){
                    console.log(that.currentCol,"Document catch Ctrl+V")
                    that.onPaste(that.currentIndex,that.currentCol);
                } 
                
            });
        },
        //获取到焦点
        getfocus(e,col,index,x){
            this.currentCol =col.prop;
            this.currentIndex =index;
            this.getFocusKeydown(e);
            if(x){
                e.$el.children[0].className = 'get-focus el-input__inner';
            }else{
                e.target.className = 'get-focus el-input__inner';
            }
            
        },
        //失去焦点
        dblur(e,x){
            if(x){
                e.$el.children[0].className = 'el-input__inner';
            }else{
                e.target.className = 'el-input__inner';
            }
            this.$emit("loseFocus", this.tableData);
        },
        channelInputLimit(e,row,prop,col){
            // col.isInteger?value=value.replace(/^[0-9]*[1-9][0-9]*$/g,''):
            let rowprop = eval('row.'+prop );
            let key = e.key;
            let ctrlKey=e.ctrlKey
            //限制长度
            if((rowprop+"").length>13 && key !== "Backspace"){
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            //整数的时候 不能输入小数点
            // console.log(col.isInteger && key === '.',col.isInteger , key === '.',key )
            if(col.isInteger && (key === '.'|| key === 'Decimal')){
              
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
            var reg = /^\d+$|^\d*\.\d+$/g;
            if (key === '.' || key === 'Decimal' ) {
                if(  rowprop == "" || this.tempkey =='.' || rowprop.toString().indexOf('.') !=-1){
                      console.log(222)
                   e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                    return false;
                }else{
                      console.log(111)
                    this.tempkey = key;
                    return true;
                }
            }else if(reg.test(key) || key === "Backspace" || (row.isFuShu && (key === 'Process' || key==='-'))){
                this.tempkey = "";
                return true;
            }else{
                e.preventDefault ? e.preventDefault() : (e.returnValue = false);
                return false;
            }
        },
        //输入监听 index下标 row 一行数据 prop 属性 e值 新数组
        inputFunc(index,row,prop,e){
            // console.log(index,row,prop,e)
            //防滚鼠标
            // e=e.replace(/[^\d.]/g,"").replace(/\.{2,}/g,".").replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');
            // e=e.replace(/[^\d.]/g,"");
            //.toFixed(2)
            //  if(!(/^(\d+\.?)?\d{0,2}$/.test(e))){
            //      console.log(/^(\d+\.?)?\d{0,2}$/.test(e),eval('row.'+prop));
            //     e = parseFloat(eval('row.'+prop));
            // }
			let that = this;
            eval('row.'+prop+"= e" );
            if(that.tableData !=undefined){
                var new_arr = JSON.parse(JSON.stringify(that.tableData));
				new_arr[index] = row;
                //回掉事件
                that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
            }
        },
        strGetVal(row,scope){
        //    console.log("scope",scope)
            if(this.formatterList && this.formatterList.indexOf(scope.column.property) != -1) {//日期格式化
				let dataStr = eval('scope.row.'+row );
				if( dataStr ){
					return moment(parseInt(dataStr)).format('YYYY-MM-DD');
				}else{
					return "";
				}
			}else if(this.formatteColumn && this.formatteColumn.name.indexOf(scope.column.property) != -1){
				return  this.formatteColumn.list[eval('scope.row.'+row )-1];
			}else if(row == "sfSales"){
                if(scope.row.sfSales){
                    if(scope.row.sfSales == "0"){
                        return "未上市";
                    }else{
                        return "已上市";
                    }
                }
			}else if (row == "reviewStatus") {
				let val = ""
				switch (scope.row.reviewStatus) {
					case "0":
						val = "未审核"
						break;
					case "1":
						val = "不通过"
						break;
					case "2":
						val = "已通过"
						break;
					default:
						val = "无"
						break;
				}
				return val	
			}else{
                return  eval('scope.row.'+row );
            }
        },
        formatter(row, column, cellValue, index) {

            // if(column.property=="sfSales"){
            //     //是否上市
            //     switch (cellValue) {
            //         case "" || null:
            //             return "/"
            //         case "0":
            //             return "未上市"
            //         case "1":
            //             return "已上市"
            //     }
            // }
		},
		formatteCol(row, column, value) {
			let prop = column.property;
			// console.log("prop",prop);
			if (prop === "personClassify") {
				if( value == "1" ){
					return "高阶岗位"
				}else if( value == "2" ){
					return "普通岗位"
				}else if( value == "3" ){
					return "实习生"
				}else if( value == "4" ){
					return "劳务工"
				}
			}else {
				return value;
			}
		},
    }
};
</script>